const makerjs = require('makerjs')

import { layerNames } from '@/js/cad/CadLayerNaming.js'

export default class Frame {
  constructor(spiceRack, materialThickness, frameInfo) {
    this.spiceRack = spiceRack
    this.materialThickness = materialThickness
    this.frameInfo = frameInfo

    this.dowelPocketDiameter = frameInfo?.dowelPocketDiameter
    this.dowelPocketInset = frameInfo?.dowelPocketInset
    this.dowelLargeSpacing = frameInfo?.dowelLargeSpacing
    this.dowelSmallSpacing = frameInfo?.dowelSmallSpacing
    this.dowelStartOffset = frameInfo?.dowelStartOffset
    this.dowelStartPosOffset = frameInfo?.dowelStartPosOffset
    this.finPocketTolerance = frameInfo?.finPocketTolerance
    this.tSlotLineGap = frameInfo?.tSlotLineGap
    this.tSlotInset = frameInfo?.tSlotInset
    this.tSlotTolerance = frameInfo?.tSlotTolerance
    this.tSlotToolDiameter = frameInfo?.tSlotToolDiameter
    this.batonPocketInset = frameInfo?.batonPocketInset
    this.batonPocketToolDiameter = frameInfo?.batonPocketToolDiameter
    this.baseShelfGap = frameInfo?.baseShelfGap
    this.smallShelfGap = frameInfo?.smallShelfGap
    this.largeShelfGap = frameInfo?.largeShelfGap
    this.frameCornerRadius = frameInfo?.frameCornerRadius

    //CALCS
    this.frameDepth = spiceRack.d
    this.frameHeight = spiceRack.h

    this.models = {
      frame: { models: {} }
    }

    this.createFrame()
  }

  createFrame() {
    const frame = (this.models.frame = { models: {} })

    // create a frame outline
    frame.models.outline = {
      layer: layerNames.cutout.label,
      paths: {
        // Bottom edge (square corners)
        bottom: new makerjs.paths.Line([0, 0], [this.frameHeight, 0]),
        // Right edge up to top-right arc
        right: new makerjs.paths.Line(
          [this.frameHeight, 0],
          [this.frameHeight, this.frameDepth - this.frameCornerRadius]
        ),
        // Top-right corner arc
        topRightArc: new makerjs.paths.Arc(
          [this.frameHeight - this.frameCornerRadius, this.frameDepth - this.frameCornerRadius],
          this.frameCornerRadius,
          0,
          90
        ),
        // Top edge between arcs
        top: new makerjs.paths.Line(
          [this.frameHeight - this.frameCornerRadius, this.frameDepth],
          [this.frameCornerRadius, this.frameDepth]
        ),
        // Top-left corner arc
        topLeftArc: new makerjs.paths.Arc(
          [this.frameCornerRadius, this.frameDepth - this.frameCornerRadius],
          this.frameCornerRadius,
          90,
          180
        ),
        // Left edge from top-left arc to bottom
        left: new makerjs.paths.Line([0, this.frameDepth - this.frameCornerRadius], [0, 0])
      }
    }

    // create fin pocket
    const finPocketWidth = this.materialThickness + this.tSlotTolerance
    const finPocketDepth = this.frameDepth - this.tSlotInset + this.batonPocketToolDiameter / 2
    const finPocket = { models: {} }
    finPocket.models.pocket = new makerjs.models.Rectangle(finPocketWidth, finPocketDepth)
    finPocket.models.pocket.layer = layerNames.urtilFinPocket.label

    // then inside it create tSlot groove paths lines
    finPocket.models.tSlotGroove = {
      layer: layerNames.tSlotGroove.label,
      paths: {
        line1: new makerjs.paths.Line(
          [this.tSlotLineGap, -this.tSlotToolDiameter / 2 + this.batonPocketToolDiameter / 2],
          [this.tSlotLineGap, this.batonPocketToolDiameter / 2 + this.frameDepth - this.tSlotInset - this.tSlotLineGap]
        ),
        line2: new makerjs.paths.Line(
          [this.tSlotLineGap, this.batonPocketToolDiameter / 2 + this.frameDepth - this.tSlotInset - this.tSlotLineGap],
          [
            finPocketWidth - this.tSlotLineGap,
            this.batonPocketToolDiameter / 2 + this.frameDepth - this.tSlotInset - this.tSlotLineGap
          ]
        ),
        line3: new makerjs.paths.Line(
          [
            finPocketWidth - this.tSlotLineGap,
            this.batonPocketToolDiameter / 2 + this.frameDepth - this.tSlotInset - this.tSlotLineGap
          ],
          [this.tSlotLineGap, this.batonPocketToolDiameter / 2 + this.frameDepth - this.tSlotInset - this.tSlotLineGap]
        ),
        line4: new makerjs.paths.Line(
          [this.tSlotLineGap, this.batonPocketToolDiameter / 2 + this.frameDepth - this.tSlotInset - this.tSlotLineGap],
          [this.tSlotLineGap, -this.tSlotToolDiameter / 2 + this.batonPocketToolDiameter / 2]
        )
      }
    }
    // position fin pocket
    for (let i = 0; i < this.spiceRack.shelves; i++) {
      frame.models['finPocket' + i] = makerjs.model.clone(finPocket)
      switch (i) {
        case 0:
          makerjs.model.move(frame.models['finPocket' + i], [
            this.frameHeight - finPocketWidth - this.baseShelfGap,
            -this.batonPocketToolDiameter / 2
          ])
          break
        case 1:
          makerjs.model.move(frame.models['finPocket' + i], [
            this.frameHeight - this.baseShelfGap - finPocketWidth * 2 - this.largeShelfGap,
            -this.batonPocketToolDiameter / 2
          ])
          break
        case 2:
          makerjs.model.move(frame.models['finPocket' + i], [
            this.frameHeight - this.baseShelfGap - finPocketWidth * 3 - this.largeShelfGap * 2,
            -this.batonPocketToolDiameter / 2
          ])
          break
        case 3:
          makerjs.model.move(frame.models['finPocket' + i], [
            this.frameHeight - this.baseShelfGap - finPocketWidth * 4 - this.largeShelfGap * 2 - this.smallShelfGap,
            -this.batonPocketToolDiameter / 2
          ])
          break
        default:
          makerjs.model.move(frame.models['finPocket' + i], [0, 0])
          break
      }
    }

    // create base baton pocket
    const baseBatonPocket = new makerjs.models.Rectangle(
      this.tSlotToolDiameter + this.batonPocketToolDiameter / 2,
      this.tSlotToolDiameter / 2
    )
    baseBatonPocket.layer = layerNames.urtilFinPocket.label
    frame.models.baseBatonPocket = baseBatonPocket
    makerjs.model.move(baseBatonPocket, [this.frameHeight - this.tSlotToolDiameter, -this.batonPocketToolDiameter / 2])

    // create baton pocket
    const batonPocket = new makerjs.models.Rectangle(this.tSlotToolDiameter, this.tSlotToolDiameter / 2)
    const batonPocketDogbone = new makerjs.models.Rectangle(
      this.batonPocketToolDiameter,
      this.batonPocketToolDiameter / 2
    )
    // position batonPocketDogbone ontop of batonPocket with left edge aligned with left edge of batonPocket
    makerjs.model.move(batonPocketDogbone, [
      this.tSlotToolDiameter - this.batonPocketToolDiameter,
      this.tSlotToolDiameter / 2
    ])
    // then combine batonPocket and batonPocketDogbone
    const batonPocketCombined = makerjs.model.combine(batonPocket, batonPocketDogbone)
    batonPocketCombined.layer = layerNames.urtilFinPocket.label

    // loop through shelves and copy then position baton pocket from 2nd shelf onwards
    for (let i = 1; i < this.spiceRack.shelves; i++) {
      frame.models['batonPocket' + (i + 1)] = makerjs.model.clone(batonPocketCombined)
      switch (i) {
        case 1:
          makerjs.model.move(frame.models['batonPocket' + (i + 1)], [
            this.frameHeight -
              this.baseShelfGap -
              finPocketWidth -
              this.largeShelfGap -
              this.batonPocketToolDiameter / 2,
            -this.batonPocketToolDiameter / 2
          ])
          break
        case 2:
          makerjs.model.move(frame.models['batonPocket' + (i + 1)], [
            this.frameHeight -
              this.baseShelfGap -
              finPocketWidth * 2 -
              this.largeShelfGap * 2 -
              this.batonPocketToolDiameter / 2,
            -this.batonPocketToolDiameter / 2
          ])
          break
        case 3:
          makerjs.model.move(frame.models['batonPocket' + (i + 1)], [
            this.frameHeight -
              this.baseShelfGap -
              finPocketWidth * 3 -
              this.largeShelfGap * 2 -
              this.smallShelfGap -
              this.batonPocketToolDiameter / 2,
            -this.batonPocketToolDiameter / 2
          ])
          break
        default:
          makerjs.model.move(frame.models['batonPocket' + (i + 1)], [0, 0])
          break
      }
    }

    // create dowel pockets
    const dowelPocket = new makerjs.models.Ellipse(this.dowelPocketDiameter / 2, this.dowelPocketDiameter / 2)
    dowelPocket.layer = layerNames.spiceRackDowelPocket.label

    // loop through shelves and copy then position dowel pocket for each shelf
    for (let i = 0; i < this.spiceRack.shelves; i++) {
      switch (i) {
        case 0:
          frame.models['dowelPocket' + i] = makerjs.layout.cloneToRow(dowelPocket, 2, -this.dowelLargeSpacing)
          makerjs.model.move(frame.models['dowelPocket' + i], [
            this.frameHeight - this.baseShelfGap - finPocketWidth - this.dowelStartOffset,
            this.frameDepth - this.dowelPocketInset
          ])
          break
        case 1:
          if (this.spiceRack.shelves === 2) {
            frame.models['dowelPocket' + i] = makerjs.layout.cloneToRow(dowelPocket, 2, -this.dowelSmallSpacing)
          } else {
            frame.models['dowelPocket' + i] = makerjs.layout.cloneToRow(dowelPocket, 2, -this.dowelLargeSpacing)
          }
          makerjs.model.move(frame.models['dowelPocket' + i], [
            this.frameHeight - this.baseShelfGap - finPocketWidth * 2 - this.largeShelfGap - this.dowelStartOffset,
            this.frameDepth - this.dowelPocketInset
          ])
          break
        case 2:
          frame.models['dowelPocket' + i] = makerjs.layout.cloneToRow(dowelPocket, 2, -this.dowelSmallSpacing)
          makerjs.model.move(frame.models['dowelPocket' + i], [
            this.frameHeight - this.baseShelfGap - finPocketWidth * 3 - this.largeShelfGap * 2 - this.dowelStartOffset,
            this.frameDepth - this.dowelPocketInset
          ])
          break
        case 3:
          frame.models['dowelPocket' + i] = makerjs.layout.cloneToRow(dowelPocket, 2, -this.dowelSmallSpacing)
          makerjs.model.move(frame.models['dowelPocket' + i], [
            this.frameHeight -
              this.baseShelfGap -
              finPocketWidth * 4 -
              this.largeShelfGap * 2 -
              this.smallShelfGap -
              this.dowelStartOffset,
            this.frameDepth - this.dowelPocketInset
          ])
          break
        default:
          makerjs.model.move(frame.models['dowelPocket' + i], [0, 0])
          break
      }
    }

    // then mirror the frame models about the x-axis (flip vertically)
    const clonedFrame = makerjs.model.clone(frame)
    this.models.mirrorFrame = makerjs.model.mirror(clonedFrame, false, true)
    makerjs.model.move(this.models.mirrorFrame, [0, -this.tSlotToolDiameter])

    // change the mirrored frame's dowel pockets to use spiceRackDowelSpringPocket layer
    for (let i = 0; i < this.spiceRack.shelves; i++) {
      const dowelPocketKey = 'dowelPocket' + i
      if (this.models.mirrorFrame.models[dowelPocketKey]) {
        const dowelPocketModels = this.models.mirrorFrame.models[dowelPocketKey].models
        for (const key in dowelPocketModels) {
          dowelPocketModels[key].layer = layerNames.spiceRackDowelSpringPocket.label
        }
      }
    }

    // create tSlotToolMill
    const tSlotToolMill = new makerjs.models.Rectangle(this.tSlotToolDiameter, this.tSlotToolDiameter)
    tSlotToolMill.layer = layerNames.spiceRackTSlotToolMill.label
    // loop through shelves and copy then position tSlotToolMill for each shelf
    for (let i = 0; i < this.spiceRack.shelves; i++) {
      frame.models['tSlotToolMill' + i] = makerjs.model.clone(tSlotToolMill)
      switch (i) {
        case 0:
          makerjs.model.move(frame.models['tSlotToolMill' + i], [
            this.frameHeight - this.baseShelfGap - finPocketWidth - this.tSlotToolDiameter / 2 + this.tSlotLineGap,
            -this.tSlotToolDiameter
          ])
          break
        case 1:
          makerjs.model.move(frame.models['tSlotToolMill' + i], [
            this.frameHeight -
              this.baseShelfGap -
              finPocketWidth * 2 -
              this.largeShelfGap -
              this.tSlotToolDiameter / 2 +
              this.tSlotLineGap,
            -this.tSlotToolDiameter
          ])
          break
        case 2:
          makerjs.model.move(frame.models['tSlotToolMill' + i], [
            this.frameHeight -
              this.baseShelfGap -
              finPocketWidth * 3 -
              this.largeShelfGap * 2 -
              this.tSlotToolDiameter / 2 +
              this.tSlotLineGap,
            -this.tSlotToolDiameter
          ])
          break
        case 3:
          makerjs.model.move(frame.models['tSlotToolMill' + i], [
            this.frameHeight -
              this.baseShelfGap -
              finPocketWidth * 4 -
              this.largeShelfGap * 2 -
              this.smallShelfGap -
              this.tSlotToolDiameter / 2 +
              this.tSlotLineGap,
            -this.tSlotToolDiameter
          ])
          break
        default:
          makerjs.model.move(frame.models['tSlotToolMill' + i], [0, 0])
          break
      }
    }
  }
}
